module.exports = __webpack_public_path__ + "./welfare-workshop_6dbc5827a0f2c3e9d7cb82e336b45c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/welfare-workshop.jpg
// module id = 630
// module chunks = 0